import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {DailyLogForm} from "./DailyLogForm";
import {getDailyLog, updateDailyLog} from "../../../actions/dailyLog";

const DailyLogEdit = props => {
  const { dailylog, projectid, onSubmit, onCancel } = props;
  return <Card title='Daily Log Details' className={'edit-view'}>
    <DailyLogForm projectid={projectid} dailyLog={dailylog} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let dailylog = state.view.subview.data[props.match.params.dailyLogId];
      if (!dailylog) return { loading: true };
      return { dailylog: dailylog.resource, projectid: props.match.params.id };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getDailyLog(props.match.params.id, props.match.params.dailyLogId)),
      onSubmit: (dailyLog) => {
        dispatch(updateDailyLog(props.match.params.id, dailyLog));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(DailyLogEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogEdit.js